/**
 * Canonical access-control types shared by both dashboards.
 *
 * Components never branch on where an answer comes from (RBAC permission
 * maps vs UI-config responses) — they ask an AccessQuery and get a boolean.
 */

export enum AccessMode {
  Rbac = "rbac",
  UiConfig = "ui-config"
}

/** Which system renders a given UI surface — generic across features. */
export enum Source {
  Default = "default",
  UiConfig = "ui-config"
}

/**
 * Per-tenant render/permission strategy. Each field is an independent axis —
 * e.g. a tenant can render config-driven dashboard tabs while still being
 * gated by the RBAC permission map (accessMode), or vice versa. Grouped here
 * so a tenant's full strategy is visible/settable in one place instead of
 * scattered top-level booleans.
 */
export interface RenderStrategy {
  navbar?: Source;
  dashboardTabs?: Source;
  accessMode?: AccessMode;
  dashboardTabContent?: Source;
  dashboardSidebar?: Source;
}

/**
 * Canonical permission shape: page -> sourceEntityID -> allowed functional actions.
 * This is the shape returned by /masterDashboard/getPermissions today, and the
 * shape UI-config permission payloads are normalized into.
 */
export type PermissionMap = Record<string, Record<string, string[]>>;

export interface AccessQuery {
  page: string;
  entityIds?: string | Array<string>;
  actions?: Array<string>;
  some?: boolean;
  forbidWhenActionsPresent?: boolean;
}
